import { Discord, Twitter, Github } from '@velocity-exchange/icons';
import {
	VELOCITY_DISCORD_URL,
	VELOCITY_DOCS_URL,
	VELOCITY_GITHUB_URL,
	VELOCITY_TWITTER_URL,
} from 'src/constants/constants';

export const MORE_CATEGORY_GENERAL_LINKS = [
	{
		label: 'Disclaimers',
		href: `${VELOCITY_DOCS_URL}/legal-and-regulations/disclaimer`,
	},
	{
		label: 'Terms',
		href: `${VELOCITY_DOCS_URL}/legal-and-regulations/terms-of-use`,
	},
	{
		label: 'Data Policy',
		href: '/data-policy',
	},
	{
		label: 'Docs',
		href: VELOCITY_DOCS_URL,
	},
];

export const MORE_CATEGORY_SOCIAL_LINKS = [
	{
		icon: Discord,
		href: VELOCITY_DISCORD_URL,
	},
	{
		icon: Twitter,
		href: VELOCITY_TWITTER_URL,
	},
	{
		icon: Github,
		href: VELOCITY_GITHUB_URL,
	},
];
